import { css, cx } from "@emotion/css"

import { Dot } from "./Dot"

const styles = {
  root: css`
    display: inline-flex;
    align-items: center;
  `,
  label: css`
    font-size: 12px;
    line-height: 1;
    font-weight: 300;
  `,
  sub: css`
    margin-left: 1ch;
    font-size: 12px;
    line-height: 1;
    font-weight: 700;
  `,
}

type LegendProps = {
  label: string
  sub?: string
  color: string
  className?: string
}

export function Legend(props: LegendProps) {
  return (
    <div className={cx("Legend", styles.root, props.className)}>
      <Dot color={props.color} />
      <span className={cx("LegendLabel", styles.label)}>{props.label}</span>
      {props.sub ? <span className={styles.sub}>{props.sub}</span> : null}
    </div>
  )
}
